<template>
    <!--
            作者：luoyiming
            时间：2019-06-04
            描述：插件中心-优惠券-生成的未领取的优惠券
        -->
        <el-dialog title="生成的优惠券" :visible.sync="cardVisible" width="60%" :before-close="handleClose">
      

        <div class="user">
      <!--搜索表单-->
      <div class="common-seach-wrap">
        <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">

          <el-form-item>
            <el-button size="small" type="success" @click="onExport">导出</el-button>
          </el-form-item>
    
        </el-form>
      </div>
  
      <div class="product-content">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @cell-click="gotoOrderDetail">

          <el-table-column prop="coupon_id" label="优惠券ID"></el-table-column>
          <el-table-column prop="originCoupon.name" label="优惠券名称"></el-table-column>
          <el-table-column prop="originCoupon.coupon_type.text" label="优惠券类型"></el-table-column>
          <el-table-column prop="card_no" label="卡号"></el-table-column>
          <el-table-column prop="card_pwd" label="卡密"></el-table-column>
          <el-table-column prop="is_use" label="是否使用">
            <template slot-scope="scope">
              <div v-if="scope.row.is_use==0">
                <span>未使用</span>
              </div>
              <div v-if="scope.row.is_use==1">
                <span>使用中</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="生成时间"></el-table-column>
        </el-table>
        <!--分页-->
        <div class="pagination">
          <el-pagination @size-change="handleSizeChange" 
          @current-change="handleCurrentChange" background 
          :current-page="formInline.page" 
          :page-sizes="[20, 100,500, 1000]"

          layout="total,sizes, prev, pager, next, jumper" 
           :total="totalDataNumber"></el-pagination>
        </div>
      </div>
    </div>
</el-dialog>
  </template>
  <script>
  import CouponApi from '@/api/coupon.js';
  import qs from 'qs';
  
  export default {
    data() {
      return {
        formInline: {
          user_id: '',
          order_id: '',
          list_rows: 20,
          page: 1,
        },
        tableData: [],
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*是否加载完成*/
        loading: true,
        // is_use:['未使用','已使用'],
      };
    },
    created() {
      /*获取列表*/
      this.getData();
    },
    props: ['cardVisible', 'coupon_id'],
    methods: {
      /*获取列表*/
      getData() {
        let self = this;
        self.formInline.coupon_id = self.coupon_id;
        CouponApi.getPickUpCouponLog(self.formInline, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total
          })
          .catch(error => {});
      },
      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        self.getData();
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.formInline.page = val;
        self.loading = true;
        self.getData();
      },
  
      /*每页多少条*/
      handleSizeChange(val) {
        this.formInline.page = 1;
        this.getTableList();
      },
      onExport: function () {
        let baseUrl = window.location.protocol + '//' + window.location.host;
        window.location.href = baseUrl + '/index.php/shop/plus.coupon.coupon/exportCard?' + qs.stringify(this.formInline);
      },
      gotoOrderDetail(row, column) {
        if (column.property === 'order_id') {
          let order_id = row.order_id
          let routeUrl = this.$router.resolve({
            path: '/order/order/Detail',
            query: {order_id}
          })
          window.open(routeUrl.href, '_blank')
        }
      },
      handleClose(e) {

        if (e) {
        this.$emit('close', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('close', {
          type: 'error',
          openDialog: false
        });
      }
    },
    
    }
  };
  </script>
  
  <style lang="sass" scoped></style>
  


// WEBPACK FOOTER //
// src/views/plus/coupon/coupon/part/card.vue